var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddPictureIcon = function SvgAddPictureIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M9.25 10.848a2.811 2.811 0 1 0 5.623 0 2.811 2.811 0 0 0-5.623 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M17.077 5.593h-.982a.4.4 0 0 1-.36-.255c-.487-.982-.945-1.994-1.987-1.994H10c-.802 0-1.23.585-1.994 1.65-.285.389-.382.599-.63.599H2.878c-1.552 0-1.874.907-1.874 1.672v7.789a1.687 1.687 0 0 0 1.919 1.784h14.154a1.687 1.687 0 0 0 1.92-1.784v-7.79c0-.764-.33-1.671-1.92-1.671m-.705 5.248a4.311 4.311 0 1 1-4.31-4.304 4.32 4.32 0 0 1 4.31 4.304M4.752 8.41a.937.937 0 1 1-.575-.874.93.93 0 0 1 .575.875z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M2.878 4.836h2.25a.367.367 0 0 0 .374-.375v-.173a1.125 1.125 0 0 0-1.125-1.124h-.75a1.125 1.125 0 0 0-1.124 1.124v.173a.375.375 0 0 0 .375.375"
  })));
};
export { SvgAddPictureIcon as ReactComponent };